import { useMutation, useQueryClient } from 'react-query'

import { useCurrentSite } from '../../components/SitesProvider'
import request from '../../config/axios'
import QueryKeys from './QueryKeys'

const useDeleteProtocolDiagnosis = () => {
  const queryClient = useQueryClient()
  const currentSiteId = useCurrentSite()?.id

  return useMutation((diagnosisId: string) => {
    const url = `/impacts/protocol_diagnoses/${diagnosisId}?site_ids[]=${currentSiteId}`

    return request.delete(url).then(() => {
      queryClient.invalidateQueries(QueryKeys.patientCases({}))
    })
  })
}

export default useDeleteProtocolDiagnosis
